import {
  FETCH_BALANCE_BY_WALLET,
  FETCH_BALANCE_BY_WALLET_SUCCESS,
  FETCH_BALANCE_BY_WALLET_FAILURE,
  RESET_BALANCE_BY_WALLET,
  FETCH_BALANCE_BY_GIFT_CARD,
  FETCH_BALANCE_BY_GIFT_CARD_SUCCESS,
  FETCH_BALANCE_BY_GIFT_CARD_FAILURE,
  RESET_BALANCE_BY_GIFT_CARD,
} from "./giftBalanceTypes";

export const fetchBalanceByWallet = ({ mobileNumber }) => ({
  type: FETCH_BALANCE_BY_WALLET,
  payload: { mobileNumber },
});

export const fetchBalanceByWalletSuccess = ({ balance }) => ({
  type: FETCH_BALANCE_BY_WALLET_SUCCESS,
  payload: balance,
});

export const fetchBalanceByWalletFailure = (error) => ({
  type: FETCH_BALANCE_BY_WALLET_FAILURE,
  payload: { error },
});

export const resetBalanceByWallet = () => ({
  type: RESET_BALANCE_BY_WALLET,
});

export const fetchBalanceByGiftCard = ({ cardNumber }) => ({
  type: FETCH_BALANCE_BY_GIFT_CARD,
  payload: { cardNumber },
});

export const fetchBalanceByGiftCardSuccess = ({ balance }) => ({
  type: FETCH_BALANCE_BY_GIFT_CARD_SUCCESS,
  payload: balance,
});

export const fetchBalanceByGiftCardFailure = (error) => ({
  type: FETCH_BALANCE_BY_GIFT_CARD_FAILURE,
  payload: error,
});

export const resetBalanceByGiftCard = () => ({
  type: RESET_BALANCE_BY_GIFT_CARD,
});
